import React from 'react';
import { withRouter } from 'react-router-dom';
import CONSTANT from './../../constant';
import { getDateParts } from '../../utils';
import ModalWindow from '../../component/common/ModalWindow';
import Loader from '../../component/common/Loader';
import { getAparUserList, getHrManagerStatus } from '../../actions/AppraisalCycleAction';
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';

class ViewReports extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            list: undefined,
            count: 0,
            showLoader: false,
            showModal: false,
            selectedEmployee: null,
            modalLoading: false,
            managerStatus: null,
            search: '',
            page: 1,
            limit: 20,
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = 'View Reports - ' + CONSTANT.organisation.name;
        this.loadList();
    }

    loadList = () => {
        const { page, limit, search } = this.state;
        this.setState({ showLoader: true });
        getAparUserList(page, limit, search).then((res: any) => {
            this.setState({ list: res.result.list, count: res.result.count, showLoader: false });
        });
    };

    render() {
        const { list, count, showLoader, showModal, selectedEmployee, modalLoading, managerStatus, search, page, limit } = this.state;
        const totalPages = Math.ceil(count / limit);

        return (
            <div className="container-fluid mb-3">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card homedob">
                            <div className="row">
                                <div className="col-md-12">
                                    <h1 className="page-title">View Reports</h1>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-6" />
                                <div className="col-md-6 d-flex justify-content-end">
                                    <div className="input-group" style={{ maxWidth: '320px' }}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search employee..."
                                            value={search}
                                            onChange={this.handleSearch}
                                        />
                                        <div className="input-group-append">
                                            <span className="input-group-text">
                                                <i className="fa fa-search" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 mt-3">
                                    <div className="list-container">
                                        <div className="table-container">
                                            <div className="table-wrapper radius-4">
                                                <table className="tablen">
                                                    <thead>
                                                        <tr className='text-center'>
                                                            <th className="table-dark">Employee #</th>
                                                            <th className="table-dark">Name</th>
                                                            <th className="table-dark">Department</th>
                                                            <th className="table-dark">Designation</th>
                                                            <th className="table-dark">Unit</th>
                                                            <th className="table-dark">Is HOD?</th>
                                                            <th className="table-dark">Last Updated</th>
                                                            <th className="table-dark">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {list === undefined && (
                                                            <tr>
                                                                <td colSpan={8} className="text-center">Loading...</td>
                                                            </tr>
                                                        )}
                                                        {list !== undefined && list.length === 0 && (
                                                            <tr>
                                                                <td colSpan={8} className="text-center">No records found</td>
                                                            </tr>
                                                        )}
                                                        {list !== undefined && list.map((item: any) => {
                                                            const dated = getDateParts(item.modifiedOn);
                                                            return (
                                                                <tr key={item.code} className="c-pointer">
                                                                    <td>{item.employeeNumber}</td>
                                                                    <td>{item.name}</td>
                                                                    <td>{item.departmentName}</td>
                                                                    <td>{item.designationName}</td>
                                                                    <td>{item.unitName}</td>
                                                                    <td className="text-center">
                                                                        {item.isHOD
                                                                            ? <i className="fa fa-check-circle text-success" />
                                                                            : <i className="fa fa-times-circle text-danger" />}
                                                                    </td>
                                                                    <td>{`${dated.date}-${dated.month}-${dated.year.slice(-2)}`}</td>
                                                                    <td className="text-center">
                                                                        <button
                                                                            className="btn btn-sm submit-button"
                                                                            onClick={() => this.openReportModal(item)}
                                                                        >
                                                                            <i className="fa fa-eye mr-1" />
                                                                            View Reports
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {totalPages > 1 && (
                                    <div className="mt-4 px-3">
                                        <ResponsivePagination
                                            activeItemClassName="Pagi-number-ac"
                                            current={page}
                                            total={totalPages}
                                            onPageChange={this.handlePageChange}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {showLoader && <Loader />}

                {/* Reports Modal */}
                {showModal && selectedEmployee && (
                    <ModalWindow
                        title={`APAR Reports - ${selectedEmployee.name} (${selectedEmployee.employeeNumber})`}
                        toggleModal={this.closeModal}
                        className="apar-report-modal"
                    >
                        <div style={{ padding: '8px 4px' }}>
                            {modalLoading ? (
                                <div className="text-center py-5">
                                    <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#3580c3' }} />
                                    <p className="mt-3" style={{ color: '#888', fontSize: '14px' }}>Loading report details...</p>
                                </div>
                            ) : (() => {
                                const ms = managerStatus;

                                if (!ms || ms.employee === null || ms.message) {
                                    return (
                                        <div className="text-center py-5">
                                            <i className="fa fa-info-circle fa-3x text-warning mb-3" style={{ display: 'block' }} />
                                            <p style={{ color: '#666', fontSize: '15px' }}>{ms?.message || 'No authority record found for this employee in the active cycle'}</p>
                                        </div>
                                    );
                                }

                                const rm = ms?.reportingManager;
                                const rvm = ms?.reviewingManager;
                                const aa = ms?.acceptingAuthority;
                                const selfAppraisal = ms?.selfAppraisal;
                                const allManagersAssigned = !!(rm?.code && rvm?.code && aa?.code);
                                const isKpiApproved = !!(rm?.kpiApproved && rvm?.kpiApproved);

                                const overallStatusMap: any = {
                                    not_started: { cls: 'badge-secondary', label: 'Not Started' },
                                    pending_kpi: { cls: 'badge-warning', label: 'Pending KPI Submission' },
                                    pending_rm_approval: { cls: 'badge-warning', label: 'Pending RM KPI Approval' },
                                    pending_rvm_approval: { cls: 'badge-warning', label: 'Pending RVM KPI Approval' },
                                    pending_self_appraisal: { cls: 'badge-info', label: 'Pending Self Appraisal' },
                                    pending_reporting: { cls: 'badge-info', label: 'Pending Reporting Manager' },
                                    pending_reviewing: { cls: 'badge-info', label: 'Pending Reviewing Manager' },
                                    pending_accepting: { cls: 'badge-info', label: 'Pending Accepting Authority' },
                                    sent_back_by_rm: { cls: 'badge-danger', label: 'Sent Back by RM' },
                                    sent_back_by_rvm: { cls: 'badge-danger', label: 'Sent Back by RVM' },
                                    completed: { cls: 'badge-success', label: 'Completed' },
                                };
                                const overallInfo = overallStatusMap[ms?.overallStatus] || { cls: 'badge-secondary', label: ms?.overallStatus || 'Unknown' };

                                const cardStyle: React.CSSProperties = {
                                    border: 'none',
                                    borderRadius: '12px',
                                    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                                    transition: 'all 0.25s ease',
                                    overflow: 'hidden',
                                };
                                const cardHoverClass = 'apar-modal-card';

                                return (
                                    <div>
                                        {/* Status Banner */}
                                        <div style={{
                                            background: 'linear-gradient(135deg, #3580c3 0%, #056caf 100%)',
                                            borderRadius: '10px',
                                            padding: '10px 14px',
                                            marginBottom: '12px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            gap: '8px',
                                        }}>
                                            <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px', fontWeight: 500 }}>
                                                <i className="fa fa-bar-chart mr-2" />
                                                Overall APAR Status
                                            </div>
                                            <span className={`badge ${overallInfo.cls}`} style={{ fontSize: '12px', padding: '6px 14px', borderRadius: '20px', fontWeight: 600 }}>
                                                {overallInfo.label}
                                            </span>
                                        </div>

                                        <div className="row" style={{ margin: '0 -6px' }}>
                                            {/* Employee */}
                                            <div className="col-md-6 mb-2" style={{ padding: '0 6px' }}>
                                                <div className={`card h-100 ${cardHoverClass} ${allManagersAssigned ? 'c-pointer' : ''}`} style={{ ...cardStyle, borderLeft: '4px solid #17a2b8' }} onClick={() => allManagersAssigned && this.navigateToReport('hr', selectedEmployee)}>
                                                    <div className="card-body d-flex flex-column justify-content-between" style={{ padding: '12px 14px' }}>
                                                        <div className="text-center">
                                                            <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(23,162,184,0.1)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                                                                <i className="fa fa-id-card-o" style={{ color: '#17a2b8', fontSize: '16px' }} />
                                                            </div>
                                                            <h6 style={{ fontWeight: 700, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px', color: '#333', marginBottom: '4px' }}>Employee</h6>
                                                            <p style={{ color: '#666', fontSize: '12px', marginBottom: '5px' }}>{ms?.employeeName || selectedEmployee.name}</p>
                                                            {selfAppraisal?.submitted
                                                                ? <span className="badge badge-success" style={{ fontSize: '10px' }}>Self Appraisal Submitted</span>
                                                                : <span className="badge badge-secondary" style={{ fontSize: '10px' }}>Self Appraisal Pending</span>
                                                            }
                                                            {!allManagersAssigned && (
                                                                <p className="text-danger mt-1 mb-0" style={{ fontSize: '10px' }}>All managers must be assigned</p>
                                                            )}
                                                        </div>
                                                        <button className="btn btn-sm submit-button mt-2 align-self-center" disabled={!allManagersAssigned} onClick={(e) => { e.stopPropagation(); this.navigateToReport('hr', selectedEmployee); }} style={{ borderRadius: '20px', padding: '4px 14px', fontSize: '11px' }}>
                                                            View Report <i className="fa fa-arrow-right ml-1" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Reporting Manager */}
                                            <div className="col-md-6 mb-2" style={{ padding: '0 6px' }}>
                                                <div className={`card h-100 ${cardHoverClass} ${rm?.assessmentSubmitted ? 'c-pointer' : ''}`} style={{ ...cardStyle, borderLeft: '4px solid #007bff' }} onClick={() => rm?.assessmentSubmitted && this.navigateToReport('reporting', selectedEmployee)}>
                                                    <div className="card-body d-flex flex-column justify-content-between" style={{ padding: '12px 14px' }}>
                                                        <div className="text-center">
                                                            <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(0,123,255,0.1)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                                                                <i className="fa fa-user" style={{ color: '#007bff', fontSize: '16px' }} />
                                                            </div>
                                                            <h6 style={{ fontWeight: 700, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px', color: '#333', marginBottom: '4px' }}>Reporting Manager</h6>
                                                            <p style={{ color: '#666', fontSize: '12px', marginBottom: '5px' }}>{rm?.name || <span className="text-danger">Not Assigned</span>}</p>
                                                            <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                                                {rm?.code && <span className={`badge ${rm.kpiApproved ? 'badge-success' : 'badge-secondary'}`} style={{ fontSize: '10px' }}>{rm.kpiApproved ? 'KPI Approved' : 'KPI Pending'}</span>}
                                                                {rm?.code && <span className={`badge ${rm.assessmentSubmitted ? 'badge-success' : 'badge-secondary'}`} style={{ fontSize: '10px' }}>{rm.assessmentStatus}</span>}
                                                            </div>
                                                        </div>
                                                        <button className="btn btn-sm submit-button mt-2 align-self-center" disabled={!rm?.assessmentSubmitted} onClick={(e) => { e.stopPropagation(); this.navigateToReport('reporting', selectedEmployee); }} style={{ borderRadius: '20px', padding: '4px 14px', fontSize: '11px' }}>
                                                            View Report <i className="fa fa-arrow-right ml-1" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Reviewing Manager */}
                                            <div className="col-md-6 mb-2" style={{ padding: '0 6px' }}>
                                                <div className={`card h-100 ${cardHoverClass} ${rvm?.assessmentSubmitted ? 'c-pointer' : ''}`} style={{ ...cardStyle, borderLeft: '4px solid #fd7e14' }} onClick={() => rvm?.assessmentSubmitted && this.navigateToReport('reviewing', selectedEmployee)}>
                                                    <div className="card-body d-flex flex-column justify-content-between" style={{ padding: '12px 14px' }}>
                                                        <div className="text-center">
                                                            <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(253,126,20,0.1)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                                                                <i className="fa fa-users" style={{ color: '#fd7e14', fontSize: '16px' }} />
                                                            </div>
                                                            <h6 style={{ fontWeight: 700, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px', color: '#333', marginBottom: '4px' }}>Reviewing Manager</h6>
                                                            <p style={{ color: '#666', fontSize: '12px', marginBottom: '5px' }}>{rvm?.name || <span className="text-danger">Not Assigned</span>}</p>
                                                            <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                                                {rvm?.code && <span className={`badge ${rvm.kpiApproved ? 'badge-success' : 'badge-secondary'}`} style={{ fontSize: '10px' }}>{rvm.kpiApproved ? 'KPI Approved' : 'KPI Pending'}</span>}
                                                                {rvm?.code && <span className={`badge ${rvm.assessmentSubmitted ? 'badge-success' : 'badge-secondary'}`} style={{ fontSize: '10px' }}>{rvm.assessmentStatus}</span>}
                                                            </div>
                                                        </div>
                                                        <button className="btn btn-sm submit-button mt-2 align-self-center" disabled={!rvm?.assessmentSubmitted} onClick={(e) => { e.stopPropagation(); this.navigateToReport('reviewing', selectedEmployee); }} style={{ borderRadius: '20px', padding: '4px 14px', fontSize: '11px' }}>
                                                            View Report <i className="fa fa-arrow-right ml-1" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Accepting Authority */}
                                            <div className="col-md-6 mb-2" style={{ padding: '0 6px' }}>
                                                <div className={`card h-100 ${cardHoverClass} ${aa?.assessmentSubmitted ? 'c-pointer' : ''}`} style={{ ...cardStyle, borderLeft: '4px solid #28a745' }} onClick={() => aa?.assessmentSubmitted && this.navigateToReport('accepting', selectedEmployee)}>
                                                    <div className="card-body d-flex flex-column justify-content-between" style={{ padding: '12px 14px' }}>
                                                        <div className="text-center">
                                                            <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(40,167,69,0.1)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                                                                <i className="fa fa-check-square-o" style={{ color: '#28a745', fontSize: '16px' }} />
                                                            </div>
                                                            <h6 style={{ fontWeight: 700, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px', color: '#333', marginBottom: '4px' }}>Accepting Authority</h6>
                                                            <p style={{ color: '#666', fontSize: '12px', marginBottom: '5px' }}>{aa?.name || <span className="text-danger">Not Assigned</span>}</p>
                                                            {aa?.code && <span className={`badge ${aa.assessmentSubmitted ? 'badge-success' : 'badge-secondary'}`} style={{ fontSize: '10px' }}>{aa.assessmentStatus}</span>}
                                                        </div>
                                                        <button className="btn btn-sm submit-button mt-2 align-self-center" disabled={!aa?.assessmentSubmitted} onClick={(e) => { e.stopPropagation(); this.navigateToReport('accepting', selectedEmployee); }} style={{ borderRadius: '20px', padding: '4px 14px', fontSize: '11px' }}>
                                                            View Report <i className="fa fa-arrow-right ml-1" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* APAR Full Report */}
                                            <div className="col-md-12" style={{ padding: '0 6px' }}>
                                                <div className={`card ${cardHoverClass} c-pointer`} style={{ ...cardStyle, borderLeft: '4px solid #dc3545' }} onClick={() => this.navigateToReport('apar', selectedEmployee)}>
                                                    <div className="card-body d-flex align-items-center justify-content-between" style={{ padding: '12px 16px' }}>
                                                        <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                                                            <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(220,53,69,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                                <i className="fa fa-file-text" style={{ color: '#dc3545', fontSize: '16px' }} />
                                                            </div>
                                                            <div>
                                                                <h6 style={{ fontWeight: 700, fontSize: '12px', color: '#333', marginBottom: '1px' }}>APAR Report</h6>
                                                                <span style={{ color: '#888', fontSize: '11px' }}>View consolidated appraisal report by period</span>
                                                            </div>
                                                        </div>
                                                        <button className="btn btn-sm submit-button" onClick={(e) => { e.stopPropagation(); this.navigateToReport('apar', selectedEmployee); }} style={{ borderRadius: '20px', padding: '4px 14px', fontSize: '11px' }}>
                                                            View <i className="fa fa-arrow-right ml-1" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })()}
                        </div>
                    </ModalWindow>
                )}
            </div>
        );
    }

    handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ search: e.target.value, page: 1 }, () => {
            this.loadList();
        });
    };

    handlePageChange = (newPage: number) => {
        this.setState({ page: newPage }, () => {
            this.loadList();
        });
    };

    openReportModal = (employee: any) => {
        this.setState({ showModal: true, selectedEmployee: employee, modalLoading: true, managerStatus: null });
        getHrManagerStatus({ employeeCode: employee.code }).then((res: any) => {
            this.setState({ managerStatus: res?.result || null, modalLoading: false });
        }).catch(() => {
            this.setState({ modalLoading: false });
        });
    }

    closeModal = () => {
        this.setState({ showModal: false, selectedEmployee: null, managerStatus: null });
    }

    navigateToReport = (type: string, employee: any) => {
        this.closeModal();
        const url = `${CONSTANT.component.viewReports.url}/detail?employeeCode=${employee.code}&type=${type}`;
        this.props.history.push(url);
    }


}

export default withRouter(ViewReports);